import React from 'react';
import { Outlet, Navigate } from "react-router-dom";
import EditorSidebar from "./EditorSidebar";

export default function EditorLayout() {
  const userRole = localStorage.getItem("userRole");
  const token = localStorage.getItem("token");

  const isAuthorized = token && (userRole === "editor" || userRole === "admin");

  if (!isAuthorized) {
    return <Navigate to="/editor-login" replace />;
  }

  return (
    // DEĞİŞİKLİK: 'bg-gray-950' yerine 'bg-slate-900' (Daha yumuşak, laciverte çalan koyu gri)
    // 'fixed inset-0' ile ekranı kaplayıp arkadaki beyaz siteyi tamamen kapatıyoruz.
    <div className="fixed inset-0 flex bg-slate-900 text-slate-100 font-sans z-50 overflow-hidden selection:bg-indigo-500 selection:text-white">
      
      {/* Sol Menü */}
      <div className="flex-shrink-0 relative z-20">
        <EditorSidebar />
      </div>
      
      {/* Ana İçerik Alanı */}
      <main className="flex-1 relative w-full h-full overflow-y-auto">
        {/* Arka plana çok hafif bir ışık efekti (Gradient) ekleyerek derinlik katalım */}
        <div className="absolute top-0 left-0 w-full h-96 bg-gradient-to-b from-slate-800/50 to-transparent -z-10 pointer-events-none" />
        
        <div className="p-6 md:p-10 max-w-7xl mx-auto min-h-full pb-20">
          <Outlet />
        </div>
      </main>
    </div>
  );
}